import styled from 'styled-components'
import { CheckboxComponent, IconComponent, Indent, themeColor, themeFontFamily } from 'LibNeo'

export const IconWrapper = styled.div`
	display: flex;
	align-items: center;
`
export const ButtonsWrapper = styled.div`
	display: flex;
`

export const TitleReport = styled.span`
	display: block;
	font-family: ${themeFontFamily('SBSansText')};
	font-size: 14px;
	color: ${themeColor('gray', 8)};
	line-height: 20px;
	font-weight: 400;
`

export const FlexCentered = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`

export const HeaderWrapper = styled.div`
	display: flex;
	align-items: center;
`
export const WarningIcon = styled(IconComponent)`
	margin-left: 4px;
`

export const TextWarpper = styled(Indent)`
	color: ${themeColor('gray', 8)};
`

export const ImageWrapper = styled.img`
	width: 592px;
	height: 360px;
`

export const FooterModalTask = styled.div`
	display: flex;
	gap: 16px;
	margin-top: 24px;
`

export const СlarifyingText = styled.div`
	color: ${themeColor('gray', 8)};
	font-size: 14px;
	line-height: 20px;
`

export const Wrapper = styled.ul`
	list-style-type: disc;
	padding-left: 18px;
	margin-bottom: 16px;
`
export const Divider = styled.div`
	padding-top: 16px;
	box-shadow: 0 -1px ${themeColor('gray', 3)};
`

export const CheckboxStyle = styled(CheckboxComponent)`
	min-height: unset;
`
